import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { getDashboardMetrics } from "../services/metricsService";

export interface Metrics {
  newUsers: number;
  matches: number;
  introductions: number;
}

const useDashboard = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [metrics, setMetrics] = useState<Metrics | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMetrics = async () => {
      setLoading(true);
      setError(null);
      try {
        const accessToken = await getAccessTokenSilently();
        const data = await getDashboardMetrics(accessToken);
        setMetrics(data);
      } catch (err) {
        setError("Failed to fetch dashboard metrics");
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, [getAccessTokenSilently]);

  return { metrics, loading, error };
};

export default useDashboard;
